import { render, staticRenderFns } from "./MegaMenuBrands.vue?vue&type=template&id=6573dac2&scoped=true&"
import script from "./MegaMenuBrands.vue?vue&type=script&lang=ts&"
export * from "./MegaMenuBrands.vue?vue&type=script&lang=ts&"
import style0 from "./MegaMenuBrands.vue?vue&type=style&index=0&id=6573dac2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6573dac2",
  null
  
)

export default component.exports